interface EditedBadgeProps {
  isEdited?: boolean
}
export const EditedBadge = ({ isEdited }: EditedBadgeProps) =>
  isEdited ? (
    <span className="text-xs text-green-500 ml-2">(Edited)</span>
  ) : null
